import * as R from "ramda";
import { parseExternalReference } from "./parseExternalReference.mjs";
const getDataflowExternalReference = (structure) => {
  const dataflowDefinition = R.pipe(
    R.pathOr([], ["data", "dataflows"]),
    R.head
  )(structure);
  return parseExternalReference(dataflowDefinition, "dataflow");
};
export {
  getDataflowExternalReference
};
